import React from 'react'
import { AuthProvider, AuthContext } from '@crossfit/auth-2'
import type { TokenDetails } from '@crossfit/auth-2/dist/types/oauth/types'

const CLIENT_SECRET = import.meta.env.VITE_SSO_CLIENT_SECRET

const authConfig = {
  oAuthLogoutUrl: import.meta.env.VITE_OAUTH_LOGOUT_URL,
  oAuthRedirectUri: import.meta.env.VITE_OAUTH_REDIRECT_URI,
  oAuthAuthorizeUrl: import.meta.env.VITE_OAUTH_AUTHORIZE_URL,
  oAuthTokenUrl: import.meta.env.VITE_OAUTH_TOKEN_URL,
  clientId: import.meta.env.VITE_SSO_CLIENT_ID,
  ...(CLIENT_SECRET && { clientSecret: CLIENT_SECRET }),
}

function Provider({
  handleRecieveAccessToken,
  children,
}: {
  handleRecieveAccessToken: (tokenDetails: TokenDetails) => void
  children: React.ReactNode
}) {
  if (window.Cypress) {
    return (
      <AuthContext.Provider
        value={{
          authenticated: true,
          unauthenticated: false,
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          initiateLogin: () => {},
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          initiateLogoutFlow: () => {},
        }}
      >
        {children}
      </AuthContext.Provider>
    )
  }
  return (
    <AuthProvider
      config={{
        ...authConfig,
        onReceiveAccessToken: handleRecieveAccessToken,
      }}
    >
      {children}
    </AuthProvider>
  )
}

export default Provider
